import { cva } from 'class-variance-authority';

import { TOAST_VARIANTS } from '@core/components/Toast/constants';

export const toastVariants = cva(
  'group relative rounded-l-theme pointer-events-auto flex w-fit max-w-sm items-center gap-4 py-3 pr-0 pl-4 inset-shadow-sm shadow-lg transition-all duration-300 bg-back-light-muted text-txt-light dark:bg-back-dark-muted dark:text-txt-dark overflow-hidden border',
  {
    variants: {
      variant: {
        [TOAST_VARIANTS.default]:
          'border-primary dark:border-primary-700 inset-shadow-primary-300 dark:inset-shadow-primary-800',
        [TOAST_VARIANTS.destructive]:
          'border-red-500 dark:border-red-800 inset-shadow-red-300 dark:inset-shadow-red-800',
        [TOAST_VARIANTS.success]:
          'border-green-500 dark:border-green-800 inset-shadow-green-300 dark:inset-shadow-green-800',
        [TOAST_VARIANTS.warning]:
          'border-yellow-500 dark:border-yellow-800 inset-shadow-yellow-400 dark:inset-shadow-yellow-800',
      },
    },
    defaultVariants: {
      variant: TOAST_VARIANTS.default,
    },
  }
);

export const iconVariants = cva('rounded-full bg-linear-to-l/oklch p-2', {
  variants: {
    variant: {
      [TOAST_VARIANTS.default]: 'text-primary-800 from-primary-100 to-primary-300',
      [TOAST_VARIANTS.destructive]: 'text-red-800 from-red-100 to-red-300',
      [TOAST_VARIANTS.success]: 'text-green-800 from-green-100 to-green-300',
      [TOAST_VARIANTS.warning]: 'text-yellow-800 from-yellow-100 to-yellow-300',
    },
  },
  defaultVariants: {
    variant: TOAST_VARIANTS.default,
  },
});

export const closeButtonVariants = cva(
  'group/close flex h-10 w-10 translate-x-10 items-center justify-center rounded-l-full opacity-0 shadow-md transition-all duration-300 group-hover:translate-x-0 group-hover:opacity-100',
  {
    variants: {
      variant: {
        [TOAST_VARIANTS.default]:
          'text-primary-800 bg-primary-200 dark:bg-primary-200 hover:bg-primary-800 hover:text-primary-100',
        [TOAST_VARIANTS.destructive]:
          'text-red-800 bg-red-200 dark:bg-red-200 hover:bg-red-800 hover:text-red-100',
        [TOAST_VARIANTS.success]:
          'text-green-800 bg-green-200 dark:bg-green-200 hover:bg-green-800 hover:text-green-100',
        [TOAST_VARIANTS.warning]:
          'text-yellow-800 bg-yellow-200 dark:bg-yellow-200 hover:bg-yellow-800 hover:text-yellow-100',
      },
    },
    defaultVariants: {
      variant: TOAST_VARIANTS.default,
    },
  }
);
